import { render, staticRenderFns } from "./index.vue?vue&type=template&id=e74f17ac&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=e74f17ac&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e74f17ac",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {HomeSwiper: require('/drone/src/components/HomeSwiper/index.vue').default,Empty: require('/drone/src/components/Empty/index.vue').default,GamesAllBoxSSR: require('/drone/src/components/GamesAllBoxSSR/index.vue').default,PzImage: require('/drone/src/components/PzImage/index.vue').default,HomeAnchorSwiper: require('/drone/src/components/HomeAnchorSwiper/index.vue').default})
